import { render } from "./RuiDanger.vue?vue&type=template&id=08f0ed74"
const script = {}
script.render = render

export default script